/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Rediger",
  "i18n.actionBar.removeImage": "Fjern",
  "i18n.actionBar.swapImage": "Bytt",
  "i18n.additionalInfoItemLayers.smartSorted.new": "Nyhet!",
  "i18n.additionalProducts.addToCart": "Legg til bestilling",
  "i18n.additionalProducts.frame.description": "Aluminiumsramme av høy kvalitet: sølvfarget og matt, ekte glass, ingen lim nødvendig",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Tips:",
  "i18n.additionalProducts.frame.subtitle": "Det ferdige puslespillet er et flott minne - i vår <b>ramme</b> kommer det til å skinne.",
  "i18n.additionalProducts.frame2023.description": "Trefiberramme i toppsjiktet – enkelt å sette sammen, uten glass, inkl. puslespill lim",
  "i18n.additionalProducts.framePlastic.description": "Aluminiumsramme av høy kvalitet: sølvfarget og matt, kunstglass med antirefleksbelegg, ingen lim nødvendig",
  "i18n.additionalProducts.glue.description": "For opptil to puslespill med 1000 brikker inkl. skumapplikator",
  "i18n.additionalProducts.glue.hook": "Slik forvandles ditt puslespill til et kunstverk.\nForsegler og beskytter permanent.",
  "i18n.additionalProducts.roll.description": "For puslespill med 48 til 2000 brikker",
  "i18n.additionalProducts.roll.hook": "Ingen bord ledig? Ingen problem.\nRull sammen puslespillet, oppbevar det trygt og fortsett senere.",
  "i18n.adventCalendarOverlay.activate": "vis plasseringen av de 24 lukene",
  "i18n.adventCalendarOverlay.deactivate": "skjul plasseringen av de 24 lukene",
  "i18n.adventCalendarOverlay.notice": "(tallene og linjene trykkes ikke)",
  "i18n.button.addToCart": "Legg til handlekurv",
  "i18n.button.apply": "Bruk",
  "i18n.button.back": "Tilbake",
  "i18n.button.cancel": "Avbryt",
  "i18n.button.cancelAndFix": "Endre nå",
  "i18n.button.chooseSmartSorted": "oppgrader til SMART SORTED ",
  "i18n.button.close": "Lukk",
  "i18n.button.continue": "Fortsett",
  "i18n.button.createNewTextPlaceholders": "Skriv en tekst på puslespillet",
  "i18n.button.ignore": "Ignorer",
  "i18n.button.ignoreAndContinue": "Fortsett",
  "i18n.button.mobile.createNewTextPlaceholders": "Tekst",
  "i18n.button.noChanges": "Nei takk, lukk vinduet ",
  "i18n.button.ok": "OK",
  "i18n.button.photos": "Bilder",
  "i18n.button.retry": "Prøv på nytt",
  "i18n.button.uploadPhotos": "Last opp bilde(r)",
  "i18n.button.withSmartSorted": "oppgrader til SMART SORTED ",
  "i18n.button.withoutSmartSorted": "Nei takk, lukk vinduet ",
  "i18n.control.colorChooser.color": "Fargen",
  "i18n.control.fontChooser.placeholderText": "Font",
  "i18n.control.imageQuality.checkImages": "Kontroller bildeoppløsning",
  "i18n.control.imageQuality.imageSuitability": "Bildekvalitet",
  "i18n.control.imageQuality.indicatorAltText": "Bildekvalitet",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Velg oppsett",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "For bedre lesbarhet, reduser lengden på teksten/linjen.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Valgt font er for stor for denne teksten.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Maks. mulig fontstørrelse for denne teksten er nådd.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Min. mulig fontstørrelse for denne teksten er nådd.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Vennligst legg inn et linjeskift",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Fortsett å skrive i en annen linje eller forstørre tekstfeltet",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Vennligst sjekk teksten din, ikke alle tegn støttes av denne fonten.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Maksimalt antall tegn er nådd",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "For bedre lesbarhet, reduser lengden på teksten/linjen.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Vennligst forstørre tekstfeltet",
  "i18n.dialog.deletePlaceholder.message": "Dette trinnet kan ikke angres",
  "i18n.dialog.deletePlaceholder.title": "Vil du slette plassholderen?",
  "i18n.dialog.error.title": [
    "Det har oppstått en feil",
    "Det har oppstått noen feil"
  ],
  "i18n.dialog.insufficientImageQuality.message": "Oppløsningen på bildet er for lav til å oppnå et skarpt utskriftsresultat!",
  "i18n.dialog.smartSorted.message": "Med SMART SORTED legges puslespill med 1000 brikker på nyskapende og lettvint vis, også uten å ha motivet som forlegg. ",
  "i18n.dialog.smartSorted.title": "Garantert puslesuksess",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klikk på \"{{text}}\", for å endre tittelen på esken.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Esketittelen er ikke endret",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Fortsett uten en tittel",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Legg inn et bilde ved å klikke på plassholderen",
    "Legg inn bilder ved klikke på plassholderne"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Uendret plassholder",
    "Uendrede plassholdere"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "En plassholder har ikke blitt endret",
    "Flere plassholdere har ikke blitt endret."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Én plassholder er fortsatt tom",
    "Noen plassholdere er fortsatt tomme"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Klikk på bildet eller teksten til plassholdere for å endre samlingen",
    "Klikk på bildet og teksten til plassholdere for å endre samlingen"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "En plassholder har ikke blitt endret",
    "Noen plassholdere har ikke blitt endret"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Klikk på teksten til plassholderne for å endre teksten",
    "Klikk på teksten til plassholderne for å endre tekstene"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Uendrede plassholdere",
  "i18n.error.additionalInfoItemsError.message": "lastefeil for informasjonslaget",
  "i18n.error.additionalInfoItemsError.title": "lasting feil",
  "i18n.error.deprecatedBrowserError.message": "Din nettleser støttes dessverre ikke lenger. Vennligst oppdater den til en nyere versjon.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Det har gått for lang tid siden du startet designprosessen og den kan derfor ikke fortsettes. Vennligst start på nytt.",
  "i18n.error.designerExpiredError.title": "Designprosessen er avbrudd",
  "i18n.error.fontLoadingError.message": "En skrift kunne ikke lastes",
  "i18n.error.fontLoadingError.title": "lasting feil",
  "i18n.error.imageLoadingError.message": "Et bilde kunne ikke lastes inn. Den ble fjernet fra designområdet og galleriet.",
  "i18n.error.imageLoadingError.title": "Nedlastningsfeil",
  "i18n.error.imageProvisionError.message": "Ett eller flere bilder kunne ikke behandles. Medietypen støttes sannsynligvis ikke.",
  "i18n.error.imageProvisionError.title": "Et bilde kunne ikke behandles",
  "i18n.error.imageSelectionError.message": "Filen \"{{reference1}}\" kunne ikke behandles.",
  "i18n.error.imageSelectionError.title": "Det oppstod en feil under opplasting av bilde",
  "i18n.error.imageSizeLimitExceededError.message": "Bildet du lastet opp er for stort.\nReduser bildet ditt til under 180 megapiksler og last det opp igjen.",
  "i18n.error.imageSizeLimitExceededError.title": "Det oppstod en feil under opplasting av bilde",
  "i18n.error.imageUploadError.message": "Det oppstod et feil med Internettilkoblingen.\nPrøv igjen senere.",
  "i18n.error.imageUploadError.title": "Det oppstod en feil under opplasting av bilde",
  "i18n.error.inlineSVGLoadingError.message": "Toleranseramme \"{{reference1}}\" kunne ikke lastes inn.",
  "i18n.error.inlineSVGLoadingError.title": "Nedlastningsfeil",
  "i18n.error.invalidCharConfigError.message": "Denne skriften er ikke aktuelt, vennligst velg en annen font.",
  "i18n.error.invalidCharConfigError.title": "Skrift ikke aktuelt",
  "i18n.error.malformedProductError.message": "Ett eller flere produkter kunne ikke overføres til serveren vår. Produktet er kanskje ikke lenger tilgjengelig eller utformingen av produktet kan ha tatt for lang tid. Vi er redde for at du må begynne på nytt. Vi beklager eventuelle ulemper dette medfører.",
  "i18n.error.malformedProductError.title": "Transformasjonsfeil",
  "i18n.error.notInStockError.message": "Produktet du har valgt er for tiden dessverre ikke tilgjengelig.\nKlikk på vår logo oppe til venstre for å komme tilbake til startsiden. Der kan du velge et annet produkt.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Internettilkoblingen din ble avbrutt. Du kan fortsette å designe produktet ditt når tilkoblingen er gjenopprettet.",
  "i18n.error.templateLoadingError.message": "Oppsett \"{{ error.reference[0] }}\" kan ikke lastes inn.\nPrøv igjen senere.",
  "i18n.error.templateLoadingError.title": "Nedlastningsfeil",
  "i18n.error.transformationError.message": "Transformasjonen kunne ikke behandles",
  "i18n.error.transformationError.title": "Transformasjonsfeil",
  "i18n.error.traudlLoadingError.message": "Vennligst prøv igjen eller bruk et annet bilde.",
  "i18n.error.traudlLoadingError.title": "KI-filteret kunne ikke anvendes.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" har en ustøttet medietype.",
  "i18n.error.unsupportedMediaTypeError.title": "Det oppstod en feil under opplasting av bilde",
  "i18n.error.uploadProductError.message": "Ett eller flere produkter kan ikke overføres til serveren.\nPrøv igjen senere.",
  "i18n.error.uploadProductError.title": "Overføringsfeil",
  "i18n.error.zoomModeError.message": "Teksten fra den forrige layouten kunne ikke overtas. Vennligst skriv inn en ny tekst.",
  "i18n.error.zoomModeError.title": "Tekst ikke overtas",
  "i18n.gallery.uploadPhotos.info": "Klikk på \"Last opp bilde(r)\"-knappen",
  "i18n.gallery.uploadProgress": [
    "Laster opp bilde …",
    "Opplastede bilder: {{current}} of {{total}}"
  ],
  "i18n.price.price": "Pris",
  "i18n.price.reduction": "Du sparer",
  "i18n.price.total": "Totalbeløp",
  "i18n.priceDisplay.times": [
    "{{value}} vare på {{pricePerUnit}}",
    "{{value}} varer på {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Tilbehør (valgfritt)",
  "i18n.progressOverlay.message.lines.one": "Bra jobbet!",
  "i18n.progressOverlay.message.lines.two": "Vi klargjør neste steg til deg...",
  "i18n.template.insertText": "Du kan skrive inn en tekst her",
  "i18n.toolbox.gallery.title": "Velg bilder",
  "i18n.toolbox.image.title": "Rediger bilde",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 bilde",
    "{{value}} bilder"
  ],
  "i18n.toolbox.layout.title": "Endre oppsett",
  "i18n.toolbox.layout.triggerText": "Oppsett",
  "i18n.toolbox.preview.title": "3D-Forhåndsvisning",
  "i18n.toolbox.productChooser.title": "Endre produkt",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.text.title": "Rediger tekst"
};


export class LocaleNbNO {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
